module.exports = __webpack_public_path__ + "static/four-steps-turorial-step-4-31120c41875cf1df7a2b0f4654a01c9a.svg";